import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../Common/Configurations/AuthContext";
import { useEffect, useState } from "react";
import { showMenu } from "../Common/Layout/CompanyMenu";
import { calculateTimeLeft, isPlanExpired } from "../Common/Layout/dateUtils";

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loading, logout } = useAuth();
  const [timeLeft, setTimeLeft] = useState("");

  const planIsExpired = user ? isPlanExpired(user.endDate) : false;

  let shouldDisplayCountdown = false;
  if (user && !planIsExpired) {
    // Only calculate if the plan is not expired
    const planTypeLower = user.planType?.toLowerCase();
    if (planTypeLower === "trail" || user.isRenewal === false) {
      shouldDisplayCountdown = true;
    }
  }

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  useEffect(() => {
    if (loading || !user || !user.endDate || !shouldDisplayCountdown) {
      setTimeLeft("");
      return;
    }
    const intervalId = setInterval(() => {
      const timeLeftString = calculateTimeLeft(user.endDate);
      // If the timer expires while the user is on the page, update the status
      if (timeLeftString === "Plan Expired") {
        navigate("/subscriptionplans", { replace: true });
      } else {
        setTimeLeft(timeLeftString);
      }
    }, 1000);
    return () => clearInterval(intervalId);
  }, [user, loading, navigate, shouldDisplayCountdown]);

  useEffect(() => {
    if (loading || !user) return;
    if (planIsExpired && location.pathname !== "/subscriptionplans") {
      navigate("/subscriptionplans", { replace: true });
    }
  }, [user, loading, location.pathname, navigate, planIsExpired]);

  if (loading) return <p>Loading...</p>;
  return (
    <header id="page-topbar">
      <div className="layout-width">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box horizontal-logo">
              <h2 className="logo">{user?.brandName}</h2>
            </div>
            {!planIsExpired && (
              <button
                type="button"
                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none"
                id="topnav-hamburger-icon"
              ></button>
            )}
          </div>

          {planIsExpired ? (
            <div className="ticker-wrap mx-3">
              <div className="ticker-move fw-bold">
                To access our full suite of services like creating packages,
                booking flights & hotels, and managing leads — please subscribe
                to one of our plans below.
              </div>
            </div>
          ) : (
            <div className="d-flex align-items-right">
              <div className="dropdown ms-sm-3 header-item gap-4">
                {showMenu("Visas") && (
                  <Link className="nav-link menu-link" to={"/visaprices"}>
                    <i className="ri-passport-line  text-success me-1"></i>
                    <span data-key="t-visas">Visas</span>
                  </Link>
                )}
              </div>
            </div>
          )}

          <div className="d-flex align-items-center">
            {!planIsExpired && (
              <Link
                to="/credithistory"
                className="btn btn-soft-primary header-item d-none d-sm-flex align-items-center"
              >
                <i className="ri-copper-coin-line text-warning me-2 fs-4"></i>
                <div className="d-flex flex-column align-items-start lh-1">
                  <span className="fw-bold">{user?.connects} Connects</span>
                  <small className="text-muted">Recharge</small>
                </div>
              </Link>
            )}

            <div className="dropdown ms-sm-3 header-item topbar-user">
              <button
                type="button"
                className="btn shadow-none"
                id="page-header-user-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span className="d-flex align-items-center">
                  <span className="text-start ms-xl-2">
                    Welcome,
                    <span className="d-none text-bold d-xl-inline-block ms-1 fw-medium user-name-text">
                      {user?.brandName}
                    </span>
                    <div className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text lh-sm">
                      {user?.planType && (
                        <span className="badge bg-primary text-uppercase">
                          {user.planType}
                        </span>
                      )}
                      {shouldDisplayCountdown && timeLeft && (
                        <span className="d-block mt-1">{timeLeft}</span>
                      )}
                      {planIsExpired && (
                        <span className="d-block mt-1 text-danger fw-bold">
                          Plan Expired
                        </span>
                      )}
                    </div>
                  </span>
                </span>
              </button>
              <div className="dropdown-menu dropdown-menu-end">
                <h6 className="dropdown-header">Welcome!</h6>
                {!planIsExpired && (
                  <>
                    <Link className="dropdown-item" to={"/companyprofile"}>
                      <i className="ri-user-line text-muted fs-4 align-middle me-1" />
                      <span className="align-middle">Profile</span>
                    </Link>
                  </>
                )}
                <button className="dropdown-item" onClick={handleLogout}>
                  <i className="mdi mdi-logout text-muted fs-4 align-middle me-1" />
                  <span className="align-middle">Logout</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
